import { createTheme, createVariant, globalTheme } from '@cld/component-theme';
import { ItemProps, SuppportedLayoutTypographySize } from './types';
import { LayoutBaseProps } from './layout/common';

const { palette } = globalTheme;

const supportedSize = (size: SuppportedLayoutTypographySize) => size;

export const theme = createTheme(
  {
    selectionVariant: {
      solid: {
        background: {
          normal: {
            color: palette.primary,
            opacity: 1,
          },
          hover: {
            color: palette.primary,
            opacity: 0.12,
          },
        },
      },
      subtle: {
        background: {
          normal: {
            color: palette.primary,
            opacity: 0.06,
          },
          hover: {
            color: palette.primary,
            opacity: 0.12,
          },
        },
      },
    },
    layout: {
      iconTwoLine: {
        sizeVariant: {
          sm: {
            paddingTopAndBottom: globalTheme.spacing.xxs,
            primaryLine: {
              typographySize: supportedSize('xxs'),
              marginBottom: 0,
            },
            secondaryLine: {
              typographySize: supportedSize('xxs'),
            },
          },
          md: {
            paddingTopAndBottom: globalTheme.spacing.xxs,
            primaryLine: {
              typographySize: supportedSize('xs'),
              marginBottom: globalTheme.spacing.xxs,
            },
            secondaryLine: {
              typographySize: supportedSize('xxs'),
            },
          },
          lg: {
            paddingTopAndBottom: globalTheme.spacing.xs,
            primaryLine: {
              typographySize: supportedSize('sm'),
              marginBottom: globalTheme.spacing.xxs,
            },
            secondaryLine: {
              typographySize: supportedSize('xxs'),
            },
          },
        },
      },
      text: {
        sizeVariant: {
          sm: {
            paddingTopAndBottom: globalTheme.spacing.xs,
            typographySize: supportedSize('xs'),
          },
          md: {
            paddingTopAndBottom: globalTheme.spacing.sm,
            typographySize: supportedSize('sm'),
          },
          lg: {
            paddingTopAndBottom: globalTheme.spacing.md,
            typographySize: supportedSize('md'),
          },
        },
      },
    },
  },
  'item'
);

export const selectionVariant = createVariant((props: ItemProps) => theme.selectionVariant[props.selectionVariant || 'solid']);
export const iconTwoLineSizeVariant = createVariant((props: Pick<LayoutBaseProps, 'size'>) => theme.layout.iconTwoLine.sizeVariant[props.size || 'md']);
export const textSizeVariant = createVariant((props: Pick<LayoutBaseProps, 'size'>) => theme.layout.text.sizeVariant[props.size || 'sm']);
